"use strict";

exports.__esModule = true;
exports.default = exports.Pill = exports.Themeless = void 0;

var _styledComponents = require("styled-components");

var _styles = require("../styles");

function _templateObject8() {
  var data = _taggedTemplateLiteralLoose(["\n    display: none;\n  "]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteralLoose(["\n    transform: translateX(28px);\n  "]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteralLoose(["\n    height: 24px;\n    width: 24px;\n    background-color: white;\n    border-radius: 100px;\n    transition: all 0.4s ease;\n  "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteralLoose(["\n    position: relative;\n    display: flex;\n    align-items: center;\n    width: 58px;\n    height: 30px;\n    background-color: ", ";\n    border-radius: 100px;\n    border: 1px solid white;\n    padding: 2px;\n    box-sizing: border-box;\n    cursor: pointer;\n  "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteralLoose(["\n  "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n  "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

var KineduPalette = _styles.colorPalettes.KineduPalette;
var Themeless = {
  label: (0, _styledComponents.css)(_templateObject()),
  slider: (0, _styledComponents.css)(_templateObject2()),
  activeSlider: (0, _styledComponents.css)(_templateObject3()),
  input: (0, _styledComponents.css)(_templateObject4())
};
exports.Themeless = Themeless;
var Pill = {
  label: (0, _styledComponents.css)(_templateObject5(), KineduPalette.cognitive),
  slider: (0, _styledComponents.css)(_templateObject6()),
  activeSlider: (0, _styledComponents.css)(_templateObject7()),
  input: (0, _styledComponents.css)(_templateObject8())
};
exports.Pill = Pill;
var SwitcherThemes = {
  Themeless: Themeless,
  Pill: Pill
};
var _default = SwitcherThemes;
exports.default = _default;